import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Typography, TextField, Button, Grid, Divider } from '@material-ui/core';
import withServices from '../../../../hocs/withServices';
import { Alert, AlertTitle } from '@material-ui/lab';

const ContractData = ({ services, contract, fetchContract }) => {
    const { control, handleSubmit } = useForm();
    const [language, setLanguage] = React.useState('ru');
    const [personalInfo, setPersonalInfo] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isUnderage, setIsUnderage] = React.useState(false);


    useEffect(() => {
        setIsLoading(true);
        services.personalPage.getPersonalInformation()
            .then((response) => {
                if (response.data?.citizenship.id !== 86) {
                    setLanguage('en');
                }
                setPersonalInfo(response.data);
                setIsUnderage(new Date().getFullYear() - new Date(response.data?.dateOfBirth).getFullYear() < 18);
            })
            .finally(() => setIsLoading(false));
    }, []);

    const onSubmit = (data) => {
        services.dormContract.createContract(data)
            .then(() => fetchContract())
    };

    const renderResidenceAddress = (lang) => {
        switch (lang) {
            case 'ru':
                return (
                    <Grid item xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                        <Typography variant="h6">Адрес прописки </Typography>
                        <Alert severity="info">
                            <AlertTitle>
                                Укажите данные прописки
                            </AlertTitle>
                            (Шаблон: Республика Казахстан, г. ___________, ул. ____, д. ____, кв. ____)
                        </Alert>
                        <Controller
                            name={"residenceAddressRu"}
                            control={control}
                            defaultValue={contract?.contractData?.residenceAddressRu}
                            render={({ field }) =>
                                <TextField
                                    {...field}
                                    variant="outlined"
                                    required
                                    disabled={contract?.approved === true && contract?.contractData !== null}
                                    fullWidth
                                />
                            }
                        />
                    </Grid>
                );
            case 'en':
                return (
                    <Grid item xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                        <Typography variant="h6">Residence address</Typography>
                        <Alert severity="info">
                            <AlertTitle>
                                Fill in the registration address
                            </AlertTitle>
                            (Pattern: ___________ country, city ___________________, street. _____________, house. _________, apartment. _____________)
                        </Alert>
                        <Controller
                            name={"residenceAddressEn"}
                            control={control}
                            defaultValue={contract?.contractData?.residenceAddressEn}
                            render={({ field }) =>
                                <TextField
                                    {...field}
                                    variant="outlined"
                                    required
                                    disabled={contract?.approved === true && contract?.contractData !== null}
                                    fullWidth
                                />
                            }
                        />
                    </Grid>
                );
            default:
                return (
                    <Grid item xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                        <Typography variant="h6">Тіркелген мекен-жайы </Typography>
                        <Alert severity="info">
                            <AlertTitle>
                                Мекен-жайын толтырудағы мәліметтерді жазыңыз
                            </AlertTitle>
                            (Үлгі: Қазақстан Республикасы, ___________ қ., ____ көшесі, ___үй, __пәтер)
                        </Alert>
                        <Controller
                            name={"residenceAddressKz"}
                            control={control}
                            defaultValue={contract?.contractData?.residenceAddressKz}
                            render={({ field }) =>
                                <TextField
                                    {...field}
                                    variant="outlined"
                                    required
                                    disabled={contract?.approved === true && contract?.contractData !== null}
                                    fullWidth
                                />
                            }
                        />
                    </Grid>
                );
        }
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '30px',
                marginTop: '30px',
                marginBottom: '30px'
            }}
        >
            <Typography variant="h5">Заполните необходимые данные для заключения договора общежития</Typography>
            <Typography variant="h5">Адрес прописки для договора</Typography>
            <Divider style={{ marginTop: 10, marginBottom: 10 }} />

            <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-end", gap: 20 }}>
                <Grid container spacing={2}>
                    {renderResidenceAddress()}
                    {renderResidenceAddress(language)}
                </Grid>

                {!isLoading && isUnderage && personalInfo.citizenship.id === 86 && (
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
                            <Typography variant="h6">ФИО законного представителя</Typography>
                            <Controller
                                name={"parentFullname"}
                                control={control}
                                defaultValue={contract?.contractData?.parentFullname
                                    ?
                                    contract?.contractData?.parentFullname
                                    :
                                    personalInfo?.firstParentSurname + ' ' + personalInfo?.firstParentName + ' ' + personalInfo?.firstParentPatronymic
                                }
                                render={({ field }) =>
                                    <TextField
                                        {...field}
                                        variant="outlined"
                                        required
                                        disabled={contract?.approved === true && contract?.contractData !== null}
                                        fullWidth
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                            <Typography variant="h6">Номер телефона законного представителя</Typography>
                            <Controller
                                name={"parentPhoneNumber"}
                                control={control}
                                defaultValue={contract?.contractData?.parentPhoneNumber ? contract?.contractData?.parentPhoneNumber : personalInfo?.firstParentPhoneNumber}
                                render={({ field }) =>
                                    <TextField
                                        {...field}
                                        variant="outlined"
                                        required
                                        disabled={contract?.approved === true && contract?.contractData !== null}
                                        fullWidth
                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                )}

                {!contract?.contractData && (
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        style={{ marginTop: 20 }}
                    >
                        Сохранить
                    </Button>
                )}
            </form>
        </div>
    );
};

export default withServices()(ContractData);